import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listPlanHandlingMemos } from '@ebalance/proto/bffuser/v1/submission_management_service-SubmissionManagementService_connectquery'
import type { ListPlanHandlingMemosResponse } from '@ebalance/proto/bffuser/v1/submission_management_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import {
  type PlanTarget,
  isPlanTargetReady,
  toPlanTargetRequest,
} from '~/pages/ProcurementPlanDetail/models/planTarget'

/**
 * SubmissionManagementService.ListPlanHandlingMemos を呼ぶ hook (AC-PSM-068)。
 *
 * 履歴の取得失敗は詳細画面全体を止めない (履歴を出さないだけ。入力欄は残す) ため、
 * global QueryClient の `throwOnError: true` を `false` に上書きする
 * (useGetPlanCounterpartyMismatch と同じ扱い)。
 */
export function useListPlanHandlingMemos(
  target: PlanTarget,
): UseQueryResult<ListPlanHandlingMemosResponse, ConnectError> {
  return useQuery(listPlanHandlingMemos, toPlanTargetRequest(target), {
    enabled: isPlanTargetReady(target),
    throwOnError: false,
  })
}
